import { render, staticRenderFns } from "./ChatbotWidget.vue?vue&type=template&id=3cc0786d&scoped=true"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatbotWidget.vue?vue&type=style&index=0&id=3cc0786d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0786d",
  null
  
)

export default component.exports